// Brand icons are deprecated, this is the parsed svg downloaded from Lucide
// Actual svgs for downloaded brands can be found in /images/icons/brands
const facebook = [
  [
    'path',
    {
      d: 'M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z',
    },
  ],
];

export default facebook;
